'use strict';

var CONSTS = {
    INDENT_FROM_EDGE: 12
};

var getViewportSize = function getViewportSize() {
    return {
        height: window.document.documentElement.clientHeight,
        width: window.document.documentElement.clientWidth
    };
}; // TODO: keep window out of this file

var getRectMiddle = function getRectMiddle(rect) {
    return {
        y: Math.floor(rect.y + rect.height / 2),
        x: Math.floor(rect.x + rect.width / 2)
    };
};

var isCloseOrEqual = function isCloseOrEqual(a, b) {
    return Math.abs(a - b) < 2;
};

var getMaxAllowedBottom = function getMaxAllowedBottom(viewport) {
    return viewport.height - CONSTS.INDENT_FROM_EDGE;
};
var getMaxAllowedRight = function getMaxAllowedRight(viewport) {
    return viewport.width - CONSTS.INDENT_FROM_EDGE;
};

module.exports = {
    getViewportSize: getViewportSize,
    getRectMiddle: getRectMiddle,
    isCloseOrEqual: isCloseOrEqual,
    getMaxAllowedBottom: getMaxAllowedBottom,
    getMaxAllowedRight: getMaxAllowedRight
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/util/position.js